<div class="body">
    <p class="Titule">Asociación de suite</p>

    <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <mat-form-field class="example-form-field">
            <mat-label>ID Cliente</mat-label>
            <input matInput type="text" #IDCLIENT formControlName="clientID">
            <mat-error *ngIf="form.get('clientID')?.hasError('required')">Campo es obligatorio</mat-error>
        </mat-form-field>

        <mat-form-field class="example-form-field">
            <mat-label>Usuario</mat-label>
            <input matInput type="text" #USUARIO formControlName="user">
            <mat-error *ngIf="form.get('user')?.hasError('required')">Campo es obligatorio</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="--form-styles">
            <mat-label>Contraseña</mat-label>
            <input matInput [type]="hide ? 'password' : 'text'" formControlName="password" [autocomplete]="false" placeholder="Contraseña">
            <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide" type="button">
              <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
            <mat-error *ngIf="form.get('password')?.hasError('required')">Campo es obligatorio</mat-error>
        </mat-form-field>

        <button class="df-primario df-btn-xl" [class.spinner__btn]="loading" [disabled]="form.invalid || loading" (click)="onSubmit()">
        Guardar
      </button>
    </form>
</div>